import React, { createContext, useContext, useEffect, useState } from 'react'
import { getPeriodoMesAtual } from '../services/util/date.service'

const PickingContext = createContext()

const INITIAL_STATE = {
  pickingCodigoBarra: {
    selectedPeriodo: getPeriodoMesAtual(),
    notaFiscal: '',
  },
  pickingManual: {
    selectedPeriodo: getPeriodoMesAtual(),
  },
  pickingReconferencia: {
    selectedPeriodo: getPeriodoMesAtual(),
    notaFiscal: '',
  },
}

export const PickingContextProvider = ({ children }) => {
  const [pickingContext, setPickingContext] = useState(INITIAL_STATE)
  const [pickingCodigoBarraContext, setPickingCodigoBarraContext] = useState(
    pickingContext.pickingCodigoBarra,
  )
  const [pickingManualContext, setPickingManualContext] = useState(pickingContext.pickingManual)
  const [pickingReconferenciaContext, setPickingReconferenciaContext] = useState(
    pickingContext.pickingReconferencia,
  )

  return (
    <PickingContext.Provider
      value={{
        pickingContext,
        setPickingContext,
        pickingCodigoBarraContext,
        setPickingCodigoBarraContext,
        pickingManualContext,
        setPickingManualContext,
        pickingReconferenciaContext,
        setPickingReconferenciaContext,
      }}
    >
      {children}
    </PickingContext.Provider>
  )
}

export const usePickingContext = () => {
  const { pickingContext, setPickingContext } = useContext(PickingContext)
  return { pickingContext, setPickingContext }
}

export const usePickingCodigoBarraContext = () => {
  const { setPickingContext } = useContext(PickingContext)
  const { pickingCodigoBarraContext, setPickingCodigoBarraContext } = useContext(PickingContext)

  useEffect(() => {
    setPickingContext(prevPickingContext => ({
      ...prevPickingContext,
      pickingCodigoBarra: pickingCodigoBarraContext,
    }))
  }, [pickingCodigoBarraContext])

  return { pickingCodigoBarraContext, setPickingCodigoBarraContext }
}

export const usePickingManualContext = () => {
  const { setPickingContext } = useContext(PickingContext)
  const { pickingManualContext, setPickingManualContext } = useContext(PickingContext)

  useEffect(() => {
    setPickingContext(prevPickingContext => ({
      ...prevPickingContext,
      pickingManual: pickingManualContext,
    }))
  }, [pickingManualContext])

  return { pickingManualContext, setPickingManualContext }
}

export const usePickingReconferenciaContext = () => {
  const { setPickingContext } = useContext(PickingContext)
  const { pickingReconferenciaContext, setPickingReconferenciaContext } = useContext(PickingContext)

  useEffect(() => {
    setPickingContext(prevPickingContext => ({
      ...prevPickingContext,
      pickingReconferencia: pickingReconferenciaContext,
    }))
  }, [pickingReconferenciaContext])

  return { pickingReconferenciaContext, setPickingReconferenciaContext }
}
